// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"c203f6c2","977":"6b128108"}[chunkId] + ".chunk.js";
};